import {faMinus, faPlus} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Space, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {AiMonitoringBrandAnalysisType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import * as styles from './positioning-item.scss';

type PropsType = {
    item: AiMonitoringBrandAnalysisType['positioning']['strengths'][number];
    isStrength: boolean;
};

// A single strength or weakness with the sources the claim came from.
export function PositioningItem(props: PropsType): JSX.Element {
    const {item, isStrength} = props;
    const iconClassName = isStrength ? styles.positioning_item__strength : styles.positioning_item__weakness;

    return (
        <div className={styles.positioning_item}>
            <FontAwesomeIcon className={iconClassName} icon={isStrength ? faPlus : faMinus} />
            <div>
                <Typography.Text>{item.text}</Typography.Text>
                <div className={styles.positioning_item__sources}>
                    {item.sources.length > 0 ? (
                        <Space size={[8, 4]} wrap>
                            {item.sources.map((source) => (
                                <Typography.Text
                                    className={styles.positioning_item__source}
                                    key={source}
                                    type="secondary"
                                >
                                    {source}
                                </Typography.Text>
                            ))}
                        </Space>
                    ) : (
                        <Typography.Text className={styles.positioning_item__source} type="secondary">
                            <Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__NO_SOURCES" />
                        </Typography.Text>
                    )}
                </div>
            </div>
        </div>
    );
}
